module.exports = __webpack_public_path__ + "static/img/fefco320_1.386b8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco320_1.png
// module id = PfNr
// module chunks = 0